import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <div class="form">
            <form-row error="vm.form.errors.displayType">
                <label class="label">{{ 'forms.Display type' | translate }} *</label>
                <div class="items">
                    <ul class="checkboxes">
                        <li>
                            <label>
                                <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.displayType" type="radio" value="{{ vm.FORMS_DISPLAY_TYPE_ENUM.KEYS.ONE_PAGE }}">
                                 {{ vm.FORMS_DISPLAY_TYPE_ENUM.LABELS.ONE_PAGE }}
                            </label>
                        </li>
                        <li>
                            <label>
                                <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.displayType" type="radio" value="{{ vm.FORMS_DISPLAY_TYPE_ENUM.KEYS.SEPARATE_PAGES }}">
                                 {{ vm.FORMS_DISPLAY_TYPE_ENUM.LABELS.SEPARATE_PAGES }}
                            </label>
                        </li>
                    </ul>
                    <form-row error="vm.form.errors.questionsPerPage" ng-if="vm.form.model.displayType === vm.FORMS_DISPLAY_TYPE_ENUM.KEYS.SEPARATE_PAGES">
                        <label class="label">{{ 'forms.Questions per page' | translate }}</label>
                        <div class="items">
                            <input ng-disabled="!vm.canManageForm" type="number" ng-model="vm.form.model.questionsPerPage" class="form-control min">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </div>
            </form-row>
            <form-row error="vm.form.errors.randomizeQuestions">
                <label class="label">{{ 'forms.Randomizing' | translate }}</label>
                <div class="items">
                    <ul class="checkboxes">
                        <li>
                            <label>
                                <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.randomizeQuestions" type="checkbox">
                                    {{ 'forms.Randomize questions' | translate }}
                            </label>
                        </li>
                        <li>
                            <label>
                                <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.isRandomizedAnswers" type="checkbox">
                                    {{ 'forms.Randomize answers' | translate }}
                            </label>
                        </li>
                    </ul>
                </div>
            </form-row>
            <form-row error="vm.form.errors.isResultShown">
                <label class="label">{{ 'forms.Display results' | translate }}</label>
                <div class="items">
                    <ul class="checkboxes">
                        <li><label><input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.isResultShown" type="checkbox"> {{ 'general.Yes' | translate }}</label></li>
                    </ul>
                    <form-row error="vm.form.errors.isAnswerFeedbackShown" ng-if="vm.form.model.isResultShown">
                        <ul class="checkboxes">
                            <li><label><input ng-disabled="!vm.canManageForm"
                            ng-model="vm.form.model.isAnswerFeedbackShown" type="checkbox"> {{ 'forms.Display answer feedback' | translate }}</label></li>
                        </ul>
                    </form-row>
                    <form-row error="vm.form.errors.isQuestionFeedbackShown" ng-if="vm.form.model.isResultShown">
                        <ul class="checkboxes">
                            <li><label><input ng-disabled="!vm.canManageForm"
                            ng-model="vm.form.model.isQuestionFeedbackShown" type="checkbox"> {{ 'forms.Display question feedback' | translate }}</label></li>
                        </ul>
                    </form-row>
                    <form-row error="vm.form.errors.isTesteesAnswerHighlighted" ng-if="vm.form.model.isResultShown">
                        <ul class="checkboxes">
                            <li>
                                <label><input ng-disabled="!vm.canManageForm"
                                ng-model="vm.form.model.isTesteesAnswerHighlighted" type="checkbox"> {{ "forms.Highlight testee's answer result" | translate }}</label>
                                <tooltip html="vm.tooltipTexts.testeesAnswers" />
                            </li>
                        </ul>
                    </form-row>
                    <form-row error="vm.form.errors.isCorrectAnswerShown" ng-if="vm.form.model.isResultShown">
                        <ul class="checkboxes">
                            <li>
                                <label><input ng-disabled="!vm.canManageForm"
                                ng-model="vm.form.model.isCorrectAnswerShown" type="checkbox"> {{ 'forms.Display correct answers' | translate }}</label>
                                <tooltip html="vm.tooltipTexts.correctAnswers" />
                            </li>
                        </ul>
                    </form-row>
                    <form-row error="vm.form.errors.isCorrectAnswerShown" ng-if="vm.form.model.isResultShown">
                        <ul class="checkboxes">
                            <li><label><input ng-disabled="!vm.canManageForm"
                            ng-model="vm.form.model.isCorrectAnswerCountGrouped" type="checkbox"> {{ 'forms.Display correct answers grouped by category' | translate }}</label></li>
                        </ul>
                    </form-row>
                </div>
            </form-row>
        </div>
    `
})

export default class {
    constructor ($state, $translate, FORMS_DISPLAY_TYPE_ENUM, FormService) {
        this.$translate = $translate;
        this.$state = $state;
        this.FORMS_DISPLAY_TYPE_ENUM = FORMS_DISPLAY_TYPE_ENUM;
        this.canManageForm = FormService.canManageForm(this.form.model);
    }

    $onInit () {
        this.tooltipTexts = {
            testeesAnswers: this.$translate.instant('forms.When enabled, the system displays at the end '
            + 'of the test the testees given answer with the information whether the answer was correct or not'),
            correctAnswers: this.$translate.instant('forms.When enabled, the system displays at the end '
            + 'of the test the testees given answer with the information whether the answer was correct or not. In addition all correct answers are highlighted')
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/actions/settings/display/index.js